import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChildrenOutletContexts, NavigationStart, Router, RouterModule, RouterOutlet } from '@angular/router';;
import { NavComponent } from './shared/components/nav/nav.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { AuthService } from './services/auth.service';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { StrategyComponent } from './components/strategy/strategy.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { SocketService } from './services/socket.service';
import { slideInAnimation } from './router.animation';

import { DirectionService } from './services/direction.service';
import { TranslateService } from '@ngx-translate/core';
import { sidebarTogglerService } from './services/sidebar-toggler.service';
import { JwtService } from './services/jwt.service';
import { DialogModule } from 'primeng/dialog';
import { SinceDatePipe } from './pipes/since-date.pipe';
import { NotificationService } from './services/notification.service';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { NotificationsComponent } from './shared/components/notifications/notifications.component';
import { StrategyService } from './services/strategy.service';
import { Strategy } from './interfaces/models/strategy.model';
import { fromEvent, map, merge, Observable, of, Subscription } from 'rxjs';
import { MessagesModule } from 'primeng/messages';
import { SpinnerService } from './services/spinner.service';
import { ProgressBarModule } from 'primeng/progressbar';
import { SidebarExpanderService } from './services/sidebar-expander.service';
import { WebViewerComponent } from './webviewer/webviewer.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { SignalRService } from './services/signal-r.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    NavComponent,
    SidebarComponent,
    RouterModule,
    NgxSpinnerModule,
    DialogModule,
    CommonModule,
    SidebarModule,
    ButtonModule,
    NotificationsComponent,
    MessagesModule,
    ProgressBarModule,
    WebViewerComponent,

  ],
  animations: [
    slideInAnimation,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'smart-strategy-system';
  statusMessage = "Server is offline";
  isServerOffline = false;
  messages = [] as any[];
  networkStatus: boolean = false;
  networkStatus$: Subscription = Subscription.EMPTY;
  isAuthenticated = false;
  dir!: "rtl" | "ltr";
  notifications = [] as any[];
  selectedNotificaton = {} as any
  sidebarShown = false;
  isAllNotificationsVisible = false;
  selectedStrategy = {} as Strategy;
  progress = 0
  sidebarDynamicStatus = false;
  isMobile = false;
  showReportReminder = false;
  constructor(
    private contexts: ChildrenOutletContexts,
    private authService: AuthService,
    private socketService: SocketService,
    private directionService: DirectionService,
    private translate: TranslateService,
    private router: Router,
    private jwtService: JwtService,
    private signalRService: SignalRService,
    private sidebarTogglerService: sidebarTogglerService,
    private notificationService: NotificationService,
    private stretegyService: StrategyService,
    private SidebarExpanderService: SidebarExpanderService,
    private observer: BreakpointObserver,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.authService.authBufferSub$.subscribe(user => {
      const authenticated = !!user && this.authService.isAuthenticated();
      this.isAuthenticated = authenticated;
      if (authenticated) {
        this.sidebarTogglerService.setSidaBarState(true);
      }
    });
    // Load language from localStorage if available
    const savedLang = localStorage.getItem('lang');
    if (savedLang) {
      this.translate.use(savedLang);
      const dir = savedLang === 'ar' ? 'rtl' : 'ltr';
      this.directionService.setDirection(dir);
    }
    
    this.directionService.setCurrentDir();
    this.sidebarTogglerService.isSidebarSubject$.subscribe((status) => {
      this.sidebarShown = status;
      this.cdr.detectChanges();
    });
    this.directionService.direction$.subscribe(dir => {
      this.dir = dir;
      if (dir == 'ltr') {
        this.translate.setDefaultLang('en')
        this.messages = [{ severity: 'error', detail: 'You are offline. Please check your internet connection.' }];
      } else {
        this.translate.setDefaultLang('ar')
        this.messages = [{ severity: 'error', detail: 'لقد فقدت الاتصال بالإنترنت. يرجى التحقق من اتصالك' }];
      }


    });

    this.signalRService.connect();
    this.signalRService.testWekcomeMessage().subscribe();


    this.notificationService.openNotificationSidebar$.subscribe((status: boolean) => {

      if (status) {
        this.socketService.refreshNotification$.subscribe((response: any) => {
          this.notifications = response["data"]["notifications"];
        });
      }
      this.isAllNotificationsVisible = status;
    });

    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.notificationService.setNotificationSidebar(false);
      };
    });

    this.stretegyService.selectedStrategy$.subscribe((strategy: any) => {
      this.selectedStrategy = strategy;
    })
    this.checkNetworkStatus();

    this.SidebarExpanderService.isSidebarExpanded$.subscribe(status => {
      this.sidebarDynamicStatus = status;
    })


    this.observer.observe(['(max-width: 800px)']).subscribe((screenSize) => {
      if (screenSize.matches) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    });
    this.signalRService.receiveReminderMessage().subscribe(() => {
      this.showReportReminder = true;
    })

  }
  checkNetworkStatus() {
    this.networkStatus = navigator.onLine;
    this.networkStatus$ = merge(
      of(null),
      fromEvent(window, 'online'),
      fromEvent(window, 'offline')
    )
      .pipe(map(() => navigator.onLine))
      .subscribe(status => {
        this.networkStatus = status;
      });
  }
  getRouteAnimationData() {
    return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
  }

  checkServer() {
    this.stretegyService.checkServerStatus().subscribe(
      (response: any) => {
        if (response.isOffline) {
          this.statusMessage = 'The server is offline!';
          this.isServerOffline = true;
        }
      }
    );
  }
  getLayoutClass() {
    return {
      'layout__body--rtl': this.isAuthenticated && this.dir === 'rtl',
      'layout__body--ltr': this.isAuthenticated && this.dir === 'ltr',
      'layout__body--anonymous': !this.isAuthenticated,
    };
  }

  // Method to handle ngStyle
  getLayoutStyle() {

    if (!this.isMobile) {
      return {};
    }
    const paddingLeft = this.dir === 'ltr' && !this.sidebarDynamicStatus && this.isAuthenticated ? '250px' : '';
    const paddingRight = this.dir === 'rtl' && !this.sidebarDynamicStatus && this.isAuthenticated ? '250px' : '';
    const padding = this.sidebarShown
      ? (this.dir === 'ltr' && !this.sidebarDynamicStatus && this.isAuthenticated)
        ? '60px 0px 0px 250px'
        : '60px 250px 0px 0px'
      : '0px';

    return {
      'padding-left': paddingLeft,
      'padding-right': paddingRight,
      'padding': padding,
    };
  }
};